import { createContext } from 'react';

/**
 * The shell header's title area (left of the header actions). `PageTitle` renders the page's title into it on wide
 * screens; below `xl` the header has no room, so the title stays at the top of the page. `null` outside `AppShell`.
 */
export const PageTitleSlotContext = createContext<HTMLElement | null>(null);
